import styled from '@mint-lib/styled';
import { StepIconProps } from '@mui/material/StepIcon';

import Icon from '../Icon/Icon.jsx';

const StepContent = (propsM: StepIconProps) => {
  const { active, completed, error } = propsM;
  return (
    <StyledStepContent
      ownerState={{ completed, active, error }}
      className="styled-customized-step"
    >
      {renderStepContent(propsM)}
    </StyledStepContent>
  );
};

const renderStepContent = (state: StepIconProps) => {
  if (state.completed) {
    return (
      <Icon
        component="Checkmark"
        aria-label="checkmark-icon"
        sx={{ color: (theme) => theme.palette.success.contrastText }}
      />
    );
  }
  if (state.error) {
    return (
      <Icon
        component="Warning"
        fontSize="medium"
        aria-label="error-icon"
        sx={{ color: (theme) => theme.palette.error.contrastText }}
      />
    );
  }
  return state.icon;
};

export default StepContent;

const StyledStepContent = styled('div')<{
  ownerState: {
    completed?: boolean;
    active?: boolean;
    error?: boolean;
  };
}>(({ theme, ownerState }) => ({
  ...theme.typography.caption,
  backgroundColor: theme.palette.ui.tertiary,
  zIndex: 1,
  width: '1.5rem',
  height: '1.5rem',
  display: 'flex',
  borderRadius: '4px',
  justifyContent: 'center',
  alignItems: 'center',
  ...(ownerState.active && {
    backgroundColor: theme.palette.tertiary.light,
  }),
  ...(ownerState.completed && {
    backgroundColor: theme.palette.success.main,
  }),
  ...(ownerState.error && {
    backgroundColor: theme.palette.error.light,
  }),
}));
